import { EWalletType } from '@store/web3Store/web3Store.enums';

export enum EGTMEvents {
	walletSelected = 'walletSelected'
}

function sendGTMEvent(event: EGTMEvents, data: object) {
	if (typeof window === 'undefined') return;

	try {
		if (!event) throw new Error('event is required');

		window.dataLayer = window.dataLayer || [];

		window.dataLayer.push({
			event,
			...data
		});
	} catch (err) {
		console.error('sendGTMEvent', err);
	}
}

export function setSelectedWalletGTMEvent(protocol: EWalletType, walletName: string) {
	sendGTMEvent(EGTMEvents.walletSelected, {
		protocol,
		walletName
	});
}
